<template>
    <v-card class="mb-4">
        <v-card-text>
            <v-row align="center">
                <v-col cols="12" lg="2">
                    <h2 class="mb-0 text-dark"><img class="app-icon" src="../../assets/favicon.png" width="25"> {{app.name}}</h2>
                </v-col>
                <v-col cols="12" lg="4">
                    <div><strong>Description:</strong></div>
                    <p class="mb-0">{{app.description}}</p>
                </v-col>
                <v-col cols="12" lg="4">
                    <div><strong>key:</strong></div>
                    <p class="mb-0">{{app.key}}</p>
                </v-col>
                <v-col cols="6" lg="1">
                    <v-btn icon @click="handleEdit(app)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
<!--                    <v-switch-->
<!--                            v-model="app.is_active"-->
<!--                    ></v-switch>-->
                </v-col>
                <v-col cols="6" lg="1" class="text-right">
                    <v-btn  v-if="app.Permissions.length"
                            icon
                            @click="show = !show"
                    >
                        <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>

        <v-expand-transition>
            <div v-if="app.Permissions.length" v-show="show">
                <v-divider></v-divider>

                <v-card-text>
                    <h3>Permissions</h3>
                    <v-chip-group
                            column
                    >
                        <v-chip v-for="permission in app.Permissions" :key="permission.id" color="primary">
                            {{ permission.name }}
                        </v-chip>
                    </v-chip-group>
                </v-card-text>
            </div>
        </v-expand-transition>
    </v-card>
</template>

<script>
export default {
  props: ['app'],
  data() {
    return {
      show: false,
    };
  },
  methods: {
    handleEdit(app) {
      this.$emit('edit', app);
    },
  },
  name: 'Application',
};
</script>

<style scoped lang="sass">
    .app-icon
        vertical-align: middle
</style>
